module.exports = __webpack_public_path__ + "static/fonts/roboto-light-webfont.66efa98.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/roboto-light-webfont.woff2
// module id = 1663
// module chunks = 28